export const line = () =>
({
  canvas: [
    {
      type: 'line',
      x1: 0, y1: 0,
      x2: 520, y2: 0,
      lineWidth: 2,
      lineCap: 'round',
      lineColor: "#8493a3",
    },
  ]  
});



// WEBPACK FOOTER //
// ./src/store/generators/PDF/core/line.js